import React, { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import {
  doCreateUserWithEmailAndPassword,
  doSignInWithGoogle,
} from "../../firebase/auth";
import { useAuth } from "../../contexts/authContext";
import { addUserToDictionary } from "../../data/AsyncFunctions/getAddUserAccount";

function Signup() {
  const { userLoggedIn } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSigningUp, setIsSigningUp] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();

    if (isSigningUp) return;

    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }

    setIsSigningUp(true);
    setErrorMessage("");

    try {
      const userCredential = await doCreateUserWithEmailAndPassword(email, password);
      await addUserToDictionary(userCredential.user);
    } catch (error) {
      setErrorMessage(error.message || "Failed to create account");
    } finally {
      setIsSigningUp(false);
    }
  };

  const onGoogleSignUp = async () => {
    if (isSigningUp) return;

    setIsSigningUp(true);
    setErrorMessage("");

    try {
      const userCredential = await doSignInWithGoogle();
      await addUserToDictionary(userCredential.user);
    } catch (error) {
      setErrorMessage(error.message || "Failed to sign up with Google");
    } finally {
      setIsSigningUp(false);
    }
  };

  if (userLoggedIn) {
    return <Navigate to="/fridge" replace />;
  }

  return (
    <div className="flex justify-center mt-20 px-4">
      <div className="w-full max-w-md">
        <h1 className="text-3xl font-bold text-center mb-2">
          Create Account
        </h1>
        <p className="text-center text-gray-600 mb-8">
          Register with your email and password or continue with Google
        </p>

        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <input
              type="password"
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Confirm Password
            </label>
            <input
              type="password"
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              required
            />
          </div>

          {errorMessage && (
            <p className="text-sm text-red-600 font-medium">
              {errorMessage}
            </p>
          )}

          <button
            type="submit"
            disabled={isSigningUp}
            className="w-full rounded-md bg-indigo-600 px-4 py-2 text-white font-medium hover:bg-indigo-700 transition disabled:opacity-50"
          >
            {isSigningUp ? "Creating Account..." : "Create Account"}
          </button>
        </form>

        <div className="mt-6">
          <button
            onClick={onGoogleSignUp}
            disabled={isSigningUp}
            className="w-full rounded-md border border-gray-300 px-4 py-2 font-medium hover:bg-gray-50 transition disabled:opacity-50"
          >
            {isSigningUp ? "Signing Up..." : "Sign up with Google"}
          </button>
        </div>

        <p className="text-center text-sm text-gray-600 mt-6">
          Already have an account?
          <Link to="/login" className="ml-1 text-indigo-600 font-medium">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Signup;
